import React from 'react';
import { Platform } from 'react-native';
import { _rem } from './rem';
import { getCachedComponentStyleConfig } from './KIDBridgeCacheUtils';
const UnitsOfLength = new Set([
    'diameter',
    'borderWidth',
    'textFont',
    'arrowWidth',
    'arrowHeight',
    'arrowCornerRadius',
    'bubbleOffsetX',
    'bubbleOffsetY',
    'bubbleCornerRadius',
    'width',
    'height',
    'cornerRadius',
]);
/**
 * 长度单位自适应转换
 */
const conversionUnitOfLength = (data) => {
    if (Platform.OS === 'web') {
        return data;
    }
    Object.keys(data).forEach((key) => {
        if (typeof data[key] === 'number' && UnitsOfLength.has(key)) {
            data[key] = _rem(data[key]);
        }
    });
    return data;
};
// 显然用 hooks 比高阶函数要好啊 ┓( ´∀` )┏
export const createKidComponent = (Component) => {
    return (props) => {
        var _a, _b, _c;
        const { kid } = props;
        const data = (_c = (kid && ((_b = (_a = getCachedComponentStyleConfig(kid)) === null || _a === void 0 ? void 0 : _a.widgetStyleData) === null || _b === void 0 ? void 0 : _b.styleConfig))) !== null && _c !== void 0 ? _c : {};
        return React.createElement(Component, Object.assign({}, conversionUnitOfLength(data), props));
    };
};
